<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12">
                <v-btn color="primary" @click="addClick">
                    <v-icon small>fa-plus</v-icon>&nbsp;&nbsp;{{ $t('buttons.newBillingList') }}
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" lg="12">
                <v-card flat outlined>
                    <v-card-title>
                        {{ $t('labels.draftBillingLists') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="draftsTable.additionalFilters"
                                    :default-sort="draftsTable.defaultSort"
                                    :excel="true"
                                    :fields="draftsTable.headers"
                                    :header-selection-key="'drafts-headers'"
                                    :height="draftsTable.height"
                                    :total-records="draftsTable.total"
                                    :filter-save-key="'draftss-filters'"
                                    @excel="excelExportDrafts"
                                    @headers="selectHeaders"
                                    @reload="reloadDataForDrafts"
                                >
                                    <tr
                                        v-for="(item, key) in draftsTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClick(props.item.id, true)"
                                    >
                                        <td class="text-left font-weight-bold" @click="editClick(item.id, false)">
                                            {{ item.name }}
                                        </td>
                                        <td class="text-left font-weight-bold" @click="editClick(item.id, false)">
                                            {{ item.invoice_to_display }}
                                        </td>
                                        <td @click="editClick(item.id, false)" class="text-center">
                                            {{ item.created_on_display }}
                                        </td>
                                        <td @click="editClick(item.id, false)" class="text-center">
                                            {{ item.last_modified_display }}
                                        </td>
                                        <td @click="editClick(item.id, false)">
                                            {{ item.last_modified_by_display }}
                                        </td>
                                        <td @click="editClick(item.id, false)" class="text-right pr-10">
                                            {{ item.invoice_total_gross_display }}
                                        </td>
                                        <td @click="editClick(item.id, false)" class="text-right pr-10">
                                            {{ item.invoice_total_net_display }}
                                        </td>
                                        <td @click="editClick(item.id, false)" class="text-right pr-10t">
                                            {{ item.payslip_total_net_display }}
                                        </td>
                                        <td @click="editClick(item.id, false)" class="text-right pr-10">
                                            {{ item.net_difference_display }}
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="12" lg="12">
                <v-card flat outlined>
                    <v-card-title>
                        {{ $t('labels.confirmedBillingLists') }}
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col>
                                <TheTable
                                    :additional-filters="confirmedTable.additionalFilters"
                                    :default-sort="confirmedTable.defaultSort"
                                    :excel="true"
                                    :fields="confirmedTable.headers"
                                    :header-selection-key="'drafts-headers'"
                                    :height="confirmedTable.height"
                                    :total-records="confirmedTable.total"
                                    :filter-save-key="'confirmed-filters'"
                                    @excel="excelExportConfirmed"
                                    @headers="selectHeaders"
                                    @reload="reloadDataForConfirmed"
                                >
                                    <tr
                                        v-for="(item, key) in confirmedTable.items"
                                        :key="key"
                                        :class="{'cursor-pointer': true}"
                                        @contextmenu.prevent="editClickConfirmed(props.item.id, true)"
                                    >
                                        <td
                                            class="text-left font-weight-bold"
                                            @click="editClickConfirmed(item.id, false)"
                                        >
                                            {{ item.name }}
                                        </td>
                                        <td
                                            class="text-left font-weight-bold"
                                            @click="editClickConfirmed(item.id, false)"
                                        >
                                            {{ item.invoice_to_display }}
                                        </td>
                                        <td @click="editClickConfirmed(item.id, false)">
                                            {{ item.created_on_display }}
                                        </td>
                                        <td @click="editClickConfirmed(item.id, false)">
                                            {{ item.last_modified_display }}
                                        </td>
                                        <td @click="editClickConfirmed(item.id, false)">
                                            {{ item.last_modified_by_display }}
                                        </td>
                                        <td @click="editClickConfirmed(item.id, false)" class="text-right pr-10">
                                            {{ item.invoice_total_gross_display }}
                                        </td>
                                        <td @click="editClickConfirmed(item.id, false)" class="text-right pr-10">
                                            {{ item.invoice_total_net_display }}
                                        </td>
                                        <td @click="editClickConfirmed(item.id, false)" class="text-right pr-10">
                                            {{ item.payslip_total_net_display }}
                                        </td>
                                        <td @click="editClickConfirmed(item.id, false)" class="text-right pr-10">
                                            {{ item.net_difference_display }}
                                        </td>
                                        <td @click="editClickConfirmed(item.id, false)">
                                            <v-icon v-if="!item.archive" small>fa-check</v-icon>
                                        </td>
                                    </tr>
                                </TheTable>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import TheTable from './trinkets/TheTable';

export default {
    name: 'Entities',
    components: {TheTable},
    data: function () {
        return {
            draftsTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.name'), value: 'name', type: '', sortable: true},
                    {text: this.$t('fields.invoiceTo'), value: 'invoice_to', type: '', sortable: true},
                    {text: this.$t('fields.createdOn'), value: 'created_at', type: '', sortable: true},
                    {text: this.$t('fields.lastModified'), value: 'updated_at', type: '', sortable: true},
                    {
                        text: this.$t('fields.lastModifiedBy'),
                        value: 'last_modified_by',
                        type: '',
                        sortable: false,
                    },
                    {
                        text: this.$t('fields.invoiceTotalGross'),
                        value: 'invoice_total_gross',
                        type: '',
                        sortable: true,
                    },
                    {text: this.$t('fields.invoiceTotalNet'), value: 'invoice_total_net', type: '', sortable: true},
                    {text: this.$t('fields.payslipTotalNet'), value: 'payslip_total_net', type: '', sortable: true},
                    {text: this.$t('fields.netDifference'), value: 'net_difference', type: '', sortable: true},
                ],
                additionalFilters: [],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'created_at',
                    descending: true,
                },
            },
            confirmedTable: {
                selectedHeaders: [],
                headers: [
                    {text: this.$t('fields.name'), value: 'name', type: '', sortable: true},
                    {text: this.$t('fields.invoiceTo'), value: 'invoice_to', type: '', sortable: true},
                    {text: this.$t('fields.createdOn'), value: 'created_at', type: '', sortable: true},
                    {text: this.$t('fields.lastModified'), value: 'updated_at', type: '', sortable: true},
                    {
                        text: this.$t('fields.lastModifiedBy'),
                        value: 'last_modified_by',
                        type: '',
                        sortable: false,
                    },
                    {
                        text: this.$t('fields.invoiceTotalGross'),
                        value: 'invoice_total_gross',
                        type: '',
                        sortable: true,
                    },
                    {text: this.$t('fields.invoiceTotalNet'), value: 'invoice_total_net', type: '', sortable: true},
                    {text: this.$t('fields.payslipTotalNet'), value: 'payslip_total_net', type: '', sortable: true},
                    {text: this.$t('fields.netDifference'), value: 'net_difference', type: '', sortable: true},
                    {
                        text: this.$t('fields.active'),
                        value: 'active',
                        type: 'boolean',
                        default: null,
                        width: '150px',
                        sortable: true,
                    },
                ],
                additionalFilters: [],
                items: [],
                total: 0,
                lastRequest: null,
                height: '0px',
                defaultSort: {
                    field: 'created_at',
                    descending: true,
                },
            },
        };
    },
    methods: {
        addClick() {
            this.$router.push('/billing-list-draft/0');
        },
        editClick(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/billing-list-draft/' + id);
            } else {
                let routeData = this.$router.resolve('/drafts/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        editClickConfirmed(id, newTab = false) {
            if (!newTab) {
                this.$router.push('/billing-list-confirmed/' + id);
            } else {
                let routeData = this.$router.resolve('/drafts/' + id);
                window.open(routeData.href, '_blank');
            }
        },
        selectHeaders(headers) {
            this.draftsTable.selectedHeaders = headers;
            this.confirmedTable.selectedHeaders = headers;
        },
        reloadDataForDrafts(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall(
                'get',
                'billing-lists-drafts',
                request,
                (data, success) => {
                    if (success) {
                        vm.draftsTable.items = data.items;
                        vm.draftsTable.total = data.total;
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        reloadDataForConfirmed(request) {
            this.lastRequest = request;
            let vm = this;
            this.$APICall(
                'get',
                'billing-lists-confirmed',
                request,
                (data, success) => {
                    if (success) {
                        vm.confirmedTable.items = data.items;
                        vm.confirmedTable.total = data.total;
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        excelExportConfirmed() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'billing-lists-confirmed',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/confirmed', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        excelExportDrafts() {
            let excelRequest = JSON.parse(JSON.stringify(this.lastRequest));
            excelRequest.pagination.itemsPerPage = 999999999;
            excelRequest.pagination.page = 1;

            let vm = this;
            this.$APICall(
                'get',
                'billing-lists-drafts',
                excelRequest,
                (data, success) => {
                    if (success) {
                        vm.$APICall('post', 'excel/drafts', data.items, (data) => {
                            window.open(data.link);
                        });
                    } else {
                        vm.$alert(vm.$t('alerts.basicError'));
                    }
                },
                false,
            );
        },
        resolveWindowResize() {
            this.draftsTable.height = window.innerHeight - 510 + 'px';
            this.confirmedTable.height = window.innerHeight - 310 + 'px';
        },
    },
    mounted() {
        let elHtml = document.getElementsByTagName('html')[0];
        elHtml.style.overflowY = 'auto';
        if (!this.$myStore.state.loggedIn) {
            this.$router.replace('login');
        }
        this.$myStore.commit('setBreadcrumbs', [
            {text: this.$t('modules.bilingLists'), href: '/#/billing-lists', disabled: true},
        ]);

        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
    },
};
</script>

<style scoped></style>
